var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_686:26232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9633 3C8.3578 3 3 8.50719 3 15.2969C3 20.7286 6.44954 25.3305 11.1468 26.9902C11.7339 27.0657 11.9541 26.6885 11.9541 26.3867C11.9541 26.0849 11.9541 25.3305 11.9541 24.2744C8.65138 25.0288 7.91743 22.6147 7.91743 22.6147C7.40367 21.1813 6.59633 20.8041 6.59633 20.8041C5.49541 20.0497 6.66972 20.0497 6.66972 20.0497C7.84404 20.1251 8.50459 21.3322 8.50459 21.3322C9.6055 23.2182 11.2936 22.6901 11.9541 22.3883C12.0275 21.5585 12.3945 21.0304 12.6881 20.7286C10.0459 20.4269 7.25688 19.3707 7.25688 14.6179C7.25688 13.26 7.69725 12.2038 8.50459 11.2985C8.43119 11.0722 7.99083 9.78969 8.65138 8.12999C8.65138 8.12999 9.6789 7.82822 11.9541 9.41249C12.9083 9.11072 13.9358 9.03528 14.9633 9.03528C15.9908 9.03528 17.0183 9.18616 17.9725 9.41249C20.2477 7.82822 21.2752 8.12999 21.2752 8.12999C21.9358 9.78969 21.4954 11.0722 21.422 11.374C22.156 12.2038 22.6697 13.3354 22.6697 14.6934C22.6697 19.4461 19.8807 20.4269 17.2385 20.7286C17.6789 21.1058 18.0459 21.8603 18.0459 22.9919C18.0459 24.6516 18.0459 25.9341 18.0459 26.3867C18.0459 26.6885 18.2661 27.0657 18.8532 26.9902C23.6239 25.3305 27 20.7286 27 15.2969C26.9266 8.50719 21.5688 3 14.9633 3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_686:26232",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_686:26232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_686:26232",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.a17a6f93826b0a566a59801546a6ca04.svg";
export { ForwardRef as ReactComponent };